import { render, staticRenderFns } from "./vsm_board.vue?vue&type=template&id=83fbf2c0&scoped=true&"
import script from "./vsm_board.vue?vue&type=script&lang=js&"
export * from "./vsm_board.vue?vue&type=script&lang=js&"
import style0 from "./vsm_board.vue?vue&type=style&index=0&id=83fbf2c0&scoped=true&lang=css&"
import style1 from "./vsm_board.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fbf2c0",
  null
  
)

export default component.exports